import { Box } from "@mui/material";
import React from "react";
import { BGColor02 } from "../configs/styles/muiThemes";
import DashboardLayout from "../components/Layouts/DashboardLayout";
import ReportDownloadContent from "./ReportDownload/ReportDownloadContent";

function ReportsDownload() {
  return (
    <Box sx={styles.container}>
      <DashboardLayout activeMenu="report" activeSubMenu="orderReportDownload">
        <ReportDownloadContent />
      </DashboardLayout>
    </Box>
  );
}

export default ReportsDownload;

const styles = {
  container: {
    minHeight: { xs: "calc(100vh - 91px)", md: "100vh" },
    backgroundColor: BGColor02,
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: { xs: "20px", md: "20px" },
    p: { xs: "0px", md: "15px 25px 25px 25px" },
    mx: { xs: "15px", md: "0px" },
  },

  stickyTop: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    pb: 1.5,
    backgroundColor: BGColor02,
  },

  menuStickyLeft: {
    position: { md: "sticky", xs: "static" },
    top: 0,
    left: 0,
    height: "100vh",
    zIndex: 100,
    backgroundColor: BGColor02,
  },
};
